import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {
    ConfiguratorDatastoreService,
    ConfiguratorI18nCacheService,
    ConfiguratorProviderService,
    ConfiguratorWorkflowService,
    InlineResponse200,
    SelectGenerictemDTO,
    WorkflowDTO
} from '@tj/tj-dmp-lib-api';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'dmp-workflow-edit',
    templateUrl: './workflow-edit-old.component.html',
    styleUrls: ['./workflow-edit-old.component.scss'],
    standalone: false
})
export class WorkflowEditOldComponent implements OnInit {

    breadcrumb = [
        {label: this.translate.instant('menu.flow.label')},
        {label: this.translate.instant('menu.flow.workflows')},
        {label: 'Création'}
    ];
    description: string;
    submitted = false;
    form: UntypedFormGroup;
    actual: WorkflowDTO;
    tenant: string;

    displayTimeLine = true;

    disabled = false;

    items: MenuItem[];
    cards: Array<InlineResponse200> = [];

    constructor(
        private readonly fb: UntypedFormBuilder,
        private configuratorWorkflowService: ConfiguratorWorkflowService,
        private readonly route: ActivatedRoute,
        private readonly datastoreResourceService: ConfiguratorDatastoreService,
        private readonly i18nCacheService: ConfiguratorI18nCacheService,
        private readonly messageService: MessageService,
        private readonly router: Router,
        protected ref: ChangeDetectorRef,
        private translate: TranslateService,
        private readonly providerService: ConfiguratorProviderService
    ) {}

    ngOnInit(): void {
        this.disabled = !(this.router.url.includes('edit') || this.router.url.includes('new'));
        this.tenant = this.route.snapshot.paramMap.get('tenant');
        this.description = 'Création d\'un workflow';
        this.form = this.fb.group({
            id: [],
            partner: [''],
            name: [{value: '', disabled: this.disabled}, [Validators.required, Validators.max(255)]],
            description: [{value: '', disabled: this.disabled}, Validators.max(255)],
            tenant: [this.tenant]
        });

        this.actual = null;
        // init list
        this.initList();
        this.initOnUpdate();
    }

    private initList() {
        if (this.tenant) {
            this.items = [];
            const self = this;
            // Création du contenu du bouton menu pour la liste des process
            this.configuratorWorkflowService.getListProcess(this.tenant).subscribe(res => {
                for (const key in res) {
                    const list: Array<SelectGenerictemDTO> = res[key];
                    const items: MenuItem[] = [];
                    list.forEach(i => {
                        items.push({
                            id: i.id,
                            label: i.label,
                            title: i.title,
                            disabled: i.disable,
                            queryParams: {
                                data: i,
                                key
                            },
                            command: ((e) => self.addCard(e)).bind(self)
                        });
                    });
                    if (items.length === 0) {
                        items.push({
                            label: 'Vide',
                            disabled: true
                        });
                    }
                    this.items.push({
                        label: this.translate.instant('workflow.listProcess.' + key),
                        id: key,
                        items
                    });
                }
            });
        }
    }

    /**
     * Action d'ajout appelé par un item du bouton de process
     * @param event
     * @private
     */
    private addCard(event) {
        const item: SelectGenerictemDTO = event.item.queryParams.data as SelectGenerictemDTO;
        const key: string = event.item.queryParams.key as string;
        this.configuratorWorkflowService.getItemProcess(item.tenant, item.partner, key, item.id).subscribe(res => {
            if ((res as any).filtersJson) {
                (res as any).filters = JSON.parse((res as any).filtersJson);
            }
            // la timeline de prime ne s'actualisa pas, donc on force
            this.displayTimeLine = false;
            this.ref.detectChanges();
            this.cards.push(res);
            this.displayTimeLine = true;
            this.ref.detectChanges();
        });
    }

    initOnUpdate() {
        const id = this.route.snapshot.paramMap.get('id');
        if (id && this.tenant) {
            this.description = 'Edition d\'un workflow';
            this.breadcrumb[2].label = 'Édition';
            this.configuratorWorkflowService.getWorkflow(this.tenant, id).subscribe((res) => {
                this.actual = {
                    id: res.id,
                    partner: (res as any).partner,
                    name: res.name,
                    description: res.description
                };
                (this.actual as any).tenant = this.tenant;
                this.form.setValue(this.actual);
                this.cards = res.process;
            });
        }
    }

    get f(): { [key: string]: AbstractControl } {
        return this.form.controls;
    }

    submit() {
        this.submitted = true;
        const value = this.form.value;
        const workflowConf: WorkflowDTO = {
            id: value.id,
            process: [],
            name: value.name,
            description: value.description,
            partner: value.partner
        };

        this.cards.forEach(card => {
            workflowConf.process.push({
                type: 'PROCESS_REF',
                typeProcess: card.type,
                id: card.id
            } as any);
        });

        this.configuratorWorkflowService.createOrUpdateWorkflow(workflowConf, this.tenant).subscribe(res => {
            const navigationExtras: NavigationExtras = {state: {message: value.id ? 'success_created' : 'success_updated'}};
            this.router.navigate([`/h/workflow`], navigationExtras);
        });
    }


    public remove(card: InlineResponse200) {
        this.displayTimeLine = false;
        this.ref.detectChanges();
        this.cards = this.cards.filter(c => !(c.id === card.id && c.type === card.type));
        this.displayTimeLine = true;
        this.ref.detectChanges();
    }
}
